/**
 * Which message a failed count start deserves.
 *
 * Kept out of the component so the mapping can be read and tested on its own.
 * The generic failure is the fallback, not the answer to everything: a camera
 * that still holds an open session and a form the backend rejected are two
 * different problems for the operator standing at the pen.
 */
export function countingStartErrorKey(status) {
  // The camera still has a counting session on record and a live stream feeding it.
  if (status === 409) return 'counting_already_in_progress';

  // The backend refused the metadata: something in the form does not fit.
  if (status === 422) return 'error_invalid_metadata';

  if (status === 401) return 'session_expired';

  // No status at all means the request never reached a response - a dropped
  // network or a backend that is down.
  return 'error_starting_count';
}
